import {
  HiOutlineBuildingOffice2,
  HiOutlineChartBar,
  HiOutlineClipboardDocumentList,
  HiOutlineUserGroup,
} from "react-icons/hi2";

import WorkflowPipeline from "./WorkflowPipeline";
import StatusChart from "./StatusChart";
import RecentDossiers from "./RecentDossiers";
import CoachWorkload from "./CoachWorkload";
import DashboardAlerts from "./DashboardAlerts";

import PageCard from "../../../components/ui/pageCard/PageCard";

import "./RoleDashboard.css";

export default function OrganizationAdminDashboard({ dashboard }) {
  const organizationName = dashboard.organization?.name || "Organisatie";

  return (
    <div className="role-dashboard">
      {/* =====================================================
          ORGANIZATION HEADER
      ===================================================== */}

      <PageCard className="role-dashboard__organization-card">
        <div className="role-dashboard__organization-content">
          <div className="role-dashboard__organization-icon">
            <HiOutlineBuildingOffice2 />
          </div>

          <div className="role-dashboard__organization-info">
            <span>Organisatie</span>

            <h2>{organizationName}</h2>

            <p>
              Operationeel overzicht van coaches, trajecten en workflow binnen
              jouw organisatie.
            </p>
          </div>
        </div>

        <div className="role-dashboard__organization-meta">
          <div className="role-dashboard__organization-meta-item">
            <div className="role-dashboard__organization-meta-icon">
              <HiOutlineUserGroup />
            </div>

            <div>
              <span>Coaches</span>

              <strong>{dashboard.stats?.total_coaches || 0}</strong>
            </div>
          </div>

          <div className="role-dashboard__organization-meta-item">
            <div className="role-dashboard__organization-meta-icon">
              <HiOutlineClipboardDocumentList />
            </div>

            <div>
              <span>Dossiers</span>

              <strong>{dashboard.stats?.total_dossiers || 0}</strong>
            </div>
          </div>

          <div className="role-dashboard__organization-meta-item">
            <div className="role-dashboard__organization-meta-icon">
              <HiOutlineChartBar />
            </div>

            <div>
              <span>Actief</span>

              <strong>{dashboard.stats?.active_dossiers || 0}</strong>
            </div>
          </div>
        </div>
      </PageCard>

      {/* =====================================================
          STATS
      ===================================================== */}

      {/* =====================================================
          WORKFLOW + STATUS
      ===================================================== */}

      <div className="role-dashboard__grid role-dashboard__grid--two">
        <WorkflowPipeline items={dashboard.workflow_pipeline} />

        <StatusChart items={dashboard.status_stats} />
      </div>

      {/* =====================================================
          COACHES + ALERTS
      ===================================================== */}

      <div className="role-dashboard__grid role-dashboard__grid--two">
        <CoachWorkload
          items={dashboard.dossiers_by_coach}
          title="Coach werkbelasting"
          description="Overzicht van dossiers per coach binnen jouw organisatie."
        />

        <DashboardAlerts
          alerts={dashboard.alerts}
          title="Organisatie alerts"
          description="Belangrijke meldingen en workflowproblemen."
        />
      </div>

      {/* =====================================================
          RECENT DOSSIERS
      ===================================================== */}

      <RecentDossiers
        dossiers={dashboard.recent_dossiers}
        title="Recente trajecten"
        description="Recent bijgewerkte trajecten binnen jouw organisatie."
      />
    </div>
  );
}
